import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import styles from "./DatePickerField.module.css";

function toDayjs(value) {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
}

export default function DatePickerField({
  value = "",
  onChange,
  minDate,
  maxDate,
  format = "DD/MM/YYYY",
  disabled = false,
  error = false,
  label = "",
  className = "",
  inputClassName = "",
  wrapperClassName = "",
  views = ["year", "month", "day"],
  openTo = "day",
  sx = {},
  slotProps = {},
}) {
  const handleChange = (nextValue) => {
    if (!nextValue || !dayjs(nextValue).isValid()) {
      onChange?.("");
      return;
    }

    onChange?.(dayjs(nextValue).format("YYYY-MM-DD"));
  };

  return (
    <div className={`${styles.wrapper} ${wrapperClassName}`.trim()}>
      <DatePicker
        value={toDayjs(value)}
        minDate={toDayjs(minDate) || undefined}
        maxDate={toDayjs(maxDate) || undefined}
        format={format}
        disabled={disabled}
        views={views}
        openTo={openTo}
        onChange={handleChange}
        className={className}
        slots={{
          openPickerIcon: () => (
            <img
              src="/calender-icon.svg"
              alt="calendar"
              className={styles.calendarIcon}
            />
          ),
        }}
        slotProps={{
          ...slotProps,
          popper: {
            disablePortal: false,
            ...(slotProps.popper || {}),
            sx: {
              zIndex: 11000,
              ...(slotProps.popper?.sx || {}),
            },
          },
          dialog: {
            ...(slotProps.dialog || {}),
            sx: {
              zIndex: 11000,
              ...(slotProps.dialog?.sx || {}),
            },
          },
          mobilePaper: {
            ...(slotProps.mobilePaper || {}),
            sx: {
              zIndex: 11000,
              ...(slotProps.mobilePaper?.sx || {}),
            },
          },
          textField: {
            fullWidth: true,
            error,
            className: `${styles.input} ${inputClassName}`.trim(),
            ...(slotProps.textField || {}),
          },
        }}
        sx={{ width: "100%", ...sx }}
      />
      {label ? (
        <label className={styles.floatingLabel}>{label}</label>
      ) : null}
    </div>
  );
}
